
/* eslint-disable class-methods-use-this */
import Component from 'vue-class-component';
import Vue from 'vue';
import PlaidLink from 'vue-plaid-link';
import { Emit, Prop } from 'vue-property-decorator';
import { Alert } from '@/core/types/alert';
import { Plaid } from '@/core/types/plaid';
import { PlaidSuccess } from '@/core/types/plaid-succes';
import { PlaidEvent } from '@/core/types/plaid-event';

@Component({
	components: {
		PlaidLink,
	},
})
export default class ProfilePlaidWrapper extends Vue {
	public alert: Alert | null = null;

	@Prop()
	public plaid!: Plaid;

	@Emit('success')
	public emitSuccess(publicToken: string, metaData: any): PlaidSuccess {
		return {
			publicToken,
			metaData,
		};
	}

	@Emit('event')
	public emitEvent(eventName: string, metaData: any): PlaidEvent {
		return {
			eventName,
			metaData,
		};
	}
}
